import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    communities: [],
    dialog: false,
    community: {}
  },

  mutations: {
    setCommunities(state, payload) {
      state.communities = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedCommunity(state, payload) {
      state.community = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    }
  },

  actions: {
    read({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/community')
        .then(r => {
          commit('setCommunities', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ commit, dispatch, state }, id) {
      axios.admin
        .put('cms/community/' + id, {
          title: state.community.title,
          role: state.community.role,
          name: state.community.name,
          quote: state.community.quote,
          post_link: state.community.post_link,
          image_url: state.community.image_url,
          position: state.community.position,
          featured: state.community.featured
        })
        .then(() => {
          commit('setDialog', false)
          commit('setSelectedCommunity', {})
          dispatch('read')
        })
    },
    delete({ dispatch }, id) {
      axios.admin.put('cms/community/delete/' + id).then(() => {
        dispatch('read')
      })
    },
    publish({ dispatch }, id) {
      axios.admin.put('cms/community/publish/' + id).then(() => {
        dispatch('read')
      })
    },
    unpublish({ dispatch }, id) {
      axios.admin.put('cms/community/unpublish/' + id).then(() => {
        dispatch('read')
      })
    },
    insert({ commit, dispatch, state }) {
      axios.admin
        .post('cms/community', {
          title: state.community.title,
          role: state.community.role,
          name: state.community.name,
          quote: state.community.quote,
          post_link: state.community.post_link,
          image_url: state.community.image_url,
          position: state.community.position,
          featured: state.community.featured
        })
        .then(() => {
          commit('setDialog', false)
          commit('setCommunity', {})
          dispatch('read')
        })
    }
  }
}
